<template>
  <div>
    <module-list
      :modules="modules"
      @updateSetup="doUpdate"
      @enabledChange="doChange"
    />
  </div>
</template>

<script>
import ModuleList from "@/components/ModuleList.vue";
import menuCustomization from "@/mixins/menuCustomization.js";

export default {
  components: {
    ModuleList,
  },
  mixins: [menuCustomization],
  data() {
    return {
      modules: [
        {
          id: "nav-agent",
          title: "代理管理",
          enabled: true,
          items: [
            {
              id: "agent-clientput",
              logo: "iconfont icon-dlkhbb blue-font",
              title: "代理客户报备",
              path: "/agent/clientput_list",
              enabled: true,
            },
            {
              id: "agent-clientvisit",
              logo: "iconfont icon-dlkhbf green-font",
              title: "代理客户拜访",
              path: "/agent/clientvisit_list",
              enabled: true,
            },
            {
              id: "agent-cust",
              logo: "iconfont icon-khfp orange-font",
              title: "客户分配",
              path: "/agent/cust_list",
              enabled: true,
            },
            {
              id: "agent-price",
              logo: "iconfont icon-dlbj blue-font",
              title: "代理报价",
              path: "/agent/price_list",
              enabled: true,
            },
            {
              id: "agent-performance",
              logo: "iconfont icon-yjfx orange-font",
              title: "业绩分析",
              path: "/agent/performance_list",
              enabled: true,
            },
            {
              id: "agent-list-formpanel",
              logo: "iconfont icon-dlzl blue-font",
              title: "代理资料",
              path: "/document/agent_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-sale",
          title: "销售管理",
          enabled: true,
          items: [
            {
              id: "planYear",
              logo: "iconfont icon-ywythd orange-font",
              title: "销售计划",
              path: "/sale/planyear_list",
              enabled: true,
            },
            {
              id: "sale",
              logo: "iconfont icon-xsdd blue-font",
              title: "销售订单",
              path: "/sale/order_list",
              enabled: true,
            },
            {
              id: "saleOut",
              logo: "iconfont icon-xsch green-font",
              title: "销售出货",
              path: "/sale/out_list",
              enabled: true,
            },
            {
              id: "saleIn",
              logo: "iconfont icon-xsth red-font",
              title: "销售退货",
              path: "/sale/return_list",
              enabled: true,
            },
            {
              id: "moveOutSeller",
              logo: "iconfont icon-ywythd blue-font",
              title: "业务员调货单",
              path: "/sale/move_out_seller_list",
              enabled: true,
            },
            {
              id: "quotation",
              logo: "iconfont icon-wsbj orange-font",
              title: "网上报价",
              path: "/sale/quote_list",
              enabled: true,
            },
            {
              id: "sampleReply",
              logo: "iconfont icon-ypbj orange-font",
              title: "样品报价",
              path: "/sale/sample_reply_list",
              enabled: true,
            },
            {
              id: "saleSample",
              logo: "iconfont icon-wxjd green-font",
              title: "送样管理",
              path: "/sale/sale_sample_list",
              enabled: true,
            },
            {
              id: "b2bSaleDown",
              logo: "iconfont icon-cgxj orange-font",
              title: "网上订单",
              path: "/sale/b2b_list",
              enabled: true,
            },
            {
              id: "saleBill",
              logo: "iconfont icon-xsdz red-font",
              title: "销售对账",
              path: "/sale/archeck_list_by_year",
              enabled: true,
            },
            {
              id: "deliveryreply",
              logo: "iconfont icon-jqhf green-font",
              title: "交期回复",
              path: "/sale/delivery_reply_list",
              enabled: true,
            },
            {
              id: "shipmentReminder",
              logo: "iconfont icon-tongzhi red-font",
              title: "发货提醒",
              path: "/sale/shipment_reminder_list",
              enabled: true,
            },
            {
              id: "SaleActivity",
              logo: "iconfont icon-hd green-font",
              title: "活动",
              path: "/crm/activity_list",
              enabled: true,
            },
            {
              id: "customer-list-formpanel",
              logo: "iconfont icon-kh red-font",
              title: "客户资料",
              path: "/document/customer_list",
              enabled: true,
            },
            {
              id: "ClientPut",
              logo: "iconfont icon-khbb blue-font",
              title: "客户报备",
              path: "/crm/client_put_list",
              enabled: true,
            },
            {
              id: "ClientVisit",
              logo: "iconfont icon-khbf orange-font",
              title: "客户拜访",
              path: "/crm/client_visit_list",
              enabled: true,
            },
            {
              id: "Business",
              logo: "iconfont icon-sjgl red-font",
              title: "商机管理",
              path: "/crm/business",
              enabled: true,
            },
            {
              id: "AfterSale",
              logo: "iconfont icon-shgl blue-font",
              title: "售后管理",
              path: "/crm/after_sale_list",
              enabled: true,
            },
            {
              id: "AfterSaleRepair",
              logo: "iconfont icon-shwx orange-font",
              title: "售后维修",
              path: "/crm/after_sale_repair_list",
              enabled: true,
            },
            {
              id: "AfterSalePick",
              logo: "iconfont icon-shll green-font",
              title: "售后领料",
              path: "/crm/after_sale_pick_list",
              enabled: true,
            },
            {
              id: "ServeItem",
              logo: "iconfont icon-fwxm blue-font",
              title: "服务项目",
              path: "/crm/serve_item_list",
              enabled: true,
            },
            {
              id: "ServeContract",
              logo: "iconfont icon-fwht red-font",
              title: "服务合同",
              path: "/crm/serve_contract_list",
              enabled: true,
            },
            {
              id: "ServeFee",
              logo: "iconfont icon-sfd orange-font",
              title: "收费单",
              path: "/crm/serve_fee_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-purchase",
          title: "采购管理",
          enabled: true,
          items: [
            {
              id: "application",
              logo: "iconfont icon-qgd green-font",
              title: "请购单",
              path: "/purchase/apply_list",
              enabled: true,
            },
            {
              id: "sampleBase",
              logo: "iconfont icon-dysq orange-font",
              title: "打样申请",
              path: "/purchase/sample_apply_list",
              enabled: true,
            },
            {
              id: "purchase",
              logo: "iconfont icon-cgdd blue-font",
              title: "采购订单",
              path: "/purchase/order_list",
              enabled: true,
            },
            {
              id: "purcVerifyApply",
              logo: "iconfont icon-cgsl red-font",
              title: "采购收料",
              path: "/purchase/verify_apply_list",
              enabled: true,
            },
            {
              id: "purchaseIn",
              logo: "iconfont icon-cgrk blue-font",
              title: "采购入库",
              path: "/purchase/in_list",
              enabled: true,
            },
            {
              id: "purchaseOut",
              logo: "iconfont icon-cgth red-font",
              title: "采购退货",
              path: "/purchase/return_list",
              enabled: true,
            },
            {
              id: "deliverytrace",
              logo: "iconfont icon-jqzz blue-font",
              title: "交期追踪",
              path: "/purchase/delivery_trace_list",
              enabled: true,
            },
            {
              id: "purchaseInquiry",
              logo: "iconfont icon-cgxj orange-font",
              title: "网上询价",
              path: "/purchase/inquiry_list",
              enabled: true,
            },
            {
              id: "sampleInquiry",
              logo: "iconfont icon-ypxj orange-font",
              title: "样品询价",
              path: "/purchase/sample_inquiry_list",
              enabled: true,
            },
            {
              id: "InquiryPrice",
              logo: "iconfont icon-wlhj green-font",
              title: "物料核价",
              path: "/purchase/price_list",
              enabled: true,
            },
            {
              id: "purchaseReconciliation",
              logo: "iconfont icon-cgdz red-font",
              title: "采购对账",
              path: "/purchase/apcheck_list_by_year",
              enabled: true,
            },
            {
              id: "DeliveryReminder",
              logo: "iconfont icon-tongzhi green-font",
              title: "送货通知",
              path: "/purchase/delivery_reminder_list",
              enabled: true,
            },
            {
              id: "sampleInquiryPrice",
              logo: "iconfont icon-yphj blue-font",
              title: "样品核价",
              path: "/purchase/sample_inquiry_price_list",
              enabled: true,
            },
            {
              id: "product-list-formpanel",
              logo: "iconfont icon-cpzl blue-font",
              title: "产品资料",
              path: "/document/product_list",
              enabled: true,
            },
            {
              id: "vendor-list-formpanel",
              logo: "iconfont icon-gyszl red-font",
              title: "供应商资料",
              path: "/document/vendor_list",
              enabled: true,
            },
            {
              id: "vendorQualificat-list-formpanel",
              logo: "iconfont icon-gysyj green-font",
              title: "供应商引进",
              path: "/document/vendor_apply_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-project",
          title: "研发管理",
          enabled: true,
          items: [
            {
              id: "demand",
              logo: "iconfont icon-qgd green-font",
              title: "需求单",
              path: "/plm/demand_list",
              enabled: true,
            },
            {
              id: "proj",
              logo: "iconfont icon-dysq orange-font",
              title: "项目管理",
              path: "/plm/proj_list",
              enabled: true,
            },
            {
              id: "plmProjTask",
              logo: "iconfont icon-cgdd blue-font",
              title: "项目任务",
              path: "/plm/proj_task_list",
              enabled: true,
            },
            {
              id: "plmProjCheck",
              logo: "iconfont icon-cgsl red-font",
              title: "阶段验收评审",
              path: "/plm/proj_check_list",
              enabled: true,
            },
            {
              id: "plmProblemFeedback",
              logo: "iconfont icon-gzbg blue-font",
              title: "问题反馈单",
              path: "/plm/problem_feedback_list",
              enabled: true,
            },
            {
              id: "plmProblemTask",
              logo: "iconfont icon-cgdd red-font",
              title: "问题反馈任务",
              path: "/plm/problem_task_list",
              enabled: true,
            },
            {
              id: "MarketAnalyseReport",
              logo: "iconfont icon-ipqc green-font",
              title: "市场分析报告",
              path: "/plm/market_report_list",
              enabled: true,
            },
            {
              id: "TechnicalAnalyseReport",
              logo: "iconfont icon-ipqc orange-font",
              title: "技术可行报告",
              path: "/plm/technical_report_list",
              enabled: true,
            },
            {
              id: "CostAnalyseReport",
              logo: "iconfont icon-ipqc red-font",
              title: "成本分析报告",
              path: "/plm/cost_report_list",
              enabled: true,
            },
            {
              id:"workHour",
              logo: "iconfont icon-ipqc orange-font",
              title: "研发工时分析",
              path: "/plm/work_hour_report",
              enabled: true,
            },
            {
              id: "product-list-formpanel",
              logo: "iconfont icon-cpzl blue-font",
              title: "产品资料",
              path: "/document/product_list",
              enabled: true,
            },
            {
              id: "application",
              logo: "iconfont icon-qgd green-font",
              title: "请购单",
              path: "/purchase/apply_list",
              enabled: true,
            },
            {
              id: "plmSample",
              logo: "iconfont icon-yphj orange-font",
              title: "供方样品确认",
              path: "/plm/plm_sample_list",
              enabled: true,
            },
            {
              id: "plmProjPick",
              logo: "iconfont icon-fqllmx green-font",
              title: "研发领料",
              path: "/plm/proj_pick_list",
              enabled: true,
            },
            {
              id: "ecr",
              logo: "iconfont icon-qmtz red-font",
              title: "ECR",
              path: "/plm/ecr_list",
              enabled: true,
            },
            {
              id: "BOM",
              logo: "iconfont icon-bom blue-font",
              title: "研发BOM",
              path: "/production/bom_list",
              enabled: true,
            },
            {
              id: "Make",
              logo: "iconfont icon-zzgd red-font",
              title: "研发工单",
              path: "/plm/make_list",
              enabled: true,
            },
            {
              id: "feeApply",
              logo: "iconfont icon-ypbj green-font",
              title: "费用申请",
              path: "/oa/fee_apply_list",
              enabled: true,
            },
            {
              id: "feePlease",
              logo: "iconfont icon-baoxiao orange-font",
              title: "费用报销",
              path: "/oa/fee_list",
              enabled: true,
            },
            {
              id: "supplies",
              logo: "iconfont icon-ypsq blue-font",
              title: "用品申请",
              path: "/oa/supplies_apply_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-make",
          title: "生产管理",
          enabled: true,
          items: [
            {
              id: "MakeBase",
              logo: "iconfont icon-zzgd blue-font",
              title: "制造工单",
              path: "/production/make_list",
              enabled: true,
            },
            {
              id: "Makepick",
              logo: "iconfont icon-scll green-font",
              title: "生产领料",
              path: "/production/pick_list",
              enabled: true,
            },
            {
              id: "MakeScrap",
              logo: "iconfont icon-scbf blue-font",
              title: "生产报废",
              path: "/production/scrap_list",
              enabled: true,
            },
            {
              id: "MakeIn",
              logo: "iconfont icon-scwgrk orange-font",
              title: "完工入库",
              path: "/production/in_list",
              enabled: true,
            },
            {
              id: "MakeDisassemble",
              logo: "iconfont icon-cjgd red-font",
              title: "拆解工单",
              path: "/production/disassemble_list",
              enabled: true,
            },
            {
              id: "MakeDisassemblePick",
              logo: "iconfont icon-cjllmx orange-font",
              title: "拆解领料明细",
              path: "/production/disassemble_pick_list",
              enabled: true,
            },
            {
              id: "MakeDisassembleScrap",
              logo: "iconfont icon-cjbfmx orange-font",
              title: "拆解报废明细",
              path: "/production/disassemble_scrap_list",
              enabled: true,
            },
            {
              id: "MakeDisassembleIn",
              logo: "iconfont icon-scwgrk blue-font",
              title: "拆解完工入库",
              path: "/production/disassemble_in_list",
              enabled: true,
            },
            {
              id: "MakeAuxiliaryPick",
              logo: "iconfont icon-scll red-font",
              title: "无定量辅料领料",
              path: "/production/auxiliary_pick_list",
              enabled: true,
            },
            {
              id: "MakeReturn",
              logo: "iconfont icon-sctl orange-font",
              title: "生产退料",
              path: "/production/return_list",
              enabled: true,
            },
            {
              id: "MakeRelocation",
              logo: "iconfont icon-sctl green-font",
              title: "生产挪料",
              path: "/production/relocation_list",
              enabled: true,
            },
            {
              id: "BOM",
              logo: "iconfont icon-bom blue-font",
              title: "BOM",
              path: "/production/bom_list",
              enabled: true,
            },
            {
              id: "BomComposite",
              logo: "iconfont icon-wlzhcx green-font",
              title: "物料综合查询",
              path: "/production/bom_composite_list",
              enabled: true,
            },
            {
              id: "MakeRepair",
              logo: "iconfont icon-repair red-font",
              title: "维修单",
              path: "/production/make_repair_list/",
              enabled: true,
            },
            {
              id: "MakeCut",
              logo: "iconfont icon-fqgd orange-font",
              title: "分切工单",
              path: "/production/make_cut_list/",
              enabled: true,
            },
            {
              id: "MakeCutPick",
              logo: "iconfont icon-fqllmx green-font",
              title: "分切领料明细",
              path: "/production/make_cut_pick_list/",
              enabled: true,
            },
            {
              id: "MakeCutReturn",
              logo: "iconfont icon-fqtlmx blue-font",
              title: "分切退料明细",
              path: "/production/make_cut_return_list/",
              enabled: true,
            },
            {
              id: "MakeCutScrap",
              logo: "iconfont icon-fqbfmx red-font",
              title: "分切报废明细",
              path: "/production/make_cut_scrap_list/",
              enabled: true,
            },
            {
              id: "MakeCutIn",
              logo: "iconfont icon-fqwgrk orange-font",
              title: "分切完工入库",
              path: "/production/make_cut_in_list/",
              enabled: true,
            },
            {
              id: "MakeMold",
              logo: "iconfont icon-mjgl green-font",
              title: "模具管理",
              path: "/production/make_mold_list/",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-osMake",
          title: "外协管理",
          enabled: true,
          items: [
            {
              id: "OSMake",
              logo: "iconfont icon-wxgd green-font",
              title: "外协工单",
              path: "/out_prod/make_list",
              enabled: true,
            },
            {
              id: "OsVerifyApply",
              logo: "iconfont icon-cgrk blue-font",
              title: "外协收料",
              path: "/purchase/verify_apply_list",
              enabled: true,
            },
            {
              id: "OsMakePick",
              logo: "iconfont icon-wxll blue-font",
              title: "外协领料",
              path: "/out_prod/pick_list",
              enabled: true,
            },
            {
              id: "OsMakeReturn",
              logo: "iconfont icon-wxtl blue-font",
              title: "外协退料",
              path: "/out_prod/return_list",
              enabled: true,
            },
            {
              id: "OsMakeScrap",
              logo: "iconfont icon-wxbf red-font",
              title: "外协报废",
              path: "/out_prod/scrap_list",
              enabled: true,
            },
            {
              id: "OsMakeRelocation",
              logo: "iconfont icon-wxtl green-font",
              title: "外协挪料",
              path: "/out_prod/relocation_list",
              enabled: true,
            },
            {
              id: "OsVerifyApply",
              logo: "iconfont icon-wxwgrk green-font",
              title: "完工入库",
              path: "/out_prod/in_list",
              enabled: true,
            },
            {
              id: "OsMakeCheckReturn",
              logo: "iconfont icon-wxth orange-font",
              title: "外协退货",
              path: "/out_prod/out_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-stock",
          title: "库存管理",
          enabled: true,
          items: [
            {
              id: "stockProfit",
              logo: "iconfont icon-pyrk green-font",
              title: "盘盈入库",
              path: "/stock/profit_list",
              enabled: true,
            },
            {
              id: "custProdIn",
              logo: "iconfont icon-pyrk blue-font",
              title: "客供入库",
              path: "/stock/cust_prod_in_list",
              enabled: true,
            },
            {
              id: "stockLoss",
              logo: "iconfont icon-pkck red-font",
              title: "盘亏出库",
              path: "/stock/loss_list",
              enabled: true,
            },
            {
              id: "otherIn",
              logo: "iconfont icon-qtrk orange-font",
              title: "其它入库",
              path: "/stock/othin_list",
              enabled: true,
            },
            {
              id: "otherOut",
              logo: "iconfont icon-qtck red-font",
              title: "其它出库",
              path: "/stock/othout_list",
              enabled: true,
            },
            {
              id: "verifyApply",
              logo: "iconfont icon-cgsl orange-font",
              title: "采购收料",
              path: "/stock/verifyapply_list",
              enabled: true,
            },
            {
              id: "custProdOut",
              logo: "iconfont icon-cgsl blue-font",
              title: "客供退料",
              path: "/stock/cust_prod_out_list",
              enabled: true,
            },
            {
              id: "customerReceive",
              logo: "iconfont icon-cgsl blue-font",
              title: "客供收料",
              path: "/stock/customer_receive_list",
              enabled: true,
            },
            {
              id: "appropriationInOut",
              logo: "iconfont icon-ycd blue-font",
              title: "移仓单",
              path: "/stock/move_list",
              enabled: true,
            },
            {
              id: "goodslend",
              logo: "iconfont icon-ycd red-font",
              title: "借货单",
              path: "/stock/goodslend_list",
              enabled: true,
            },
            {
              id: "goodsback",
              logo: "iconfont icon-ycd orange-font",
              title: "还货单",
              path: "/stock/goodsback_list",
              enabled: true,
            },

            {
              id: "ProductInit",
              logo: "iconfont icon-kcdr blue-font",
              title: "库存导入",
              path: "/stock/in_list",
              enabled: true,
            },
            {
              id: "sproductwhmonthadjust",
              logo: "iconfont icon-qmtz red-font",
              title: "期末调整单",
              path: "/stock/adjust_list",
              enabled: true,
            },
            {
              id: "other-warehouse",
              logo: "iconfont icon-cksz orange-font",
              title: "仓库设置",
              path: "/document/warehouse_list",
              enabled: true,
            },
            {
              id: "stockQuery",
              logo: "iconfont icon-kccx green-font",
              title: "库存查询",
              path: "/stock/query_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-iqc",
          title: "品质管理",
          enabled: true,
          items: [
            {
              id: "purcIqc",
              logo: "iconfont icon-IQCjy green-font",
              title: "IQC检验",
              path: "/qc/iqc_list",
              enabled: true,
            },
            {
              id: "firstQc",
              logo: "iconfont icon-sjjy green-font",
              title: "首件检验单",
              path: "/qc/firstqc_list",
              enabled: true,
            },
            {
              id: "ipQc",
              logo: "iconfont icon-ipqc blue-font",
              title: "IPQC检验单",
              path: "/qc/ipqc_list",
              enabled: true,
            },
            {
              id: "makeQc",
              logo: "iconfont icon-QCjy orange-font",
              title: "QC检验",
              path: "/qc/qc_list",
              enabled: true,
            },
            {
              id: "makeFqc",
              logo: "iconfont icon-foqc blue-font",
              title: "F/OQC检验",
              path: "/qc/qa_list",
              enabled: true,
            },
            {
              id: "makeQe",
              logo: "iconfont icon-QEjy blue-font",
              title: "QE分析",
              path: "/qc/qe_list",
              enabled: true,
            },
            {
              id: "mrb",
              logo: "iconfont icon-fxpg red-font",
              title: "MRB风险评估",
              path: "/qc/mrb_list",
              enabled: true,
            },
            {
              id: "improvementReport",
              logo: "iconfont icon-dlzl red-font",
              title: "8D改善报告",
              path: "/qc/improvement_report_list",
              enabled: true,
            },
            {
              id: "purcIqcReturn ",
              logo: "iconfont icon-jyth red-font",
              title: "检验退货",
              path: "/qc/iqc_return_list",
              enabled: true,
            },
            {
              id: "iqcSet",
              logo: "iconfont icon-fqgd green-font",
              title: "IQC检验设置",
              path: "/quality/iqcset_list",
              enabled: true,
            },
            {
              id: "faiSet",
              logo: "iconfont icon-jysz2 orange-font",
              title: "首件检验设置",
              path: "/quality/faiset_list",
              enabled: true,
            },
            {
              id: "ipqcSet",
              logo: "iconfont icon-ijysz blue-font",
              title: "IPQC检验设置",
              path: "/quality/ipqcset_list",
              enabled: true,
            },
            {
              id: "qcngSet",
              logo: "iconfont icon-jysz3 red-font",
              title: "QC不良设置",
              path: "/quality/qcngset_list",
              enabled: true,
            },
            {
              id: "foqcSet",
              logo: "iconfont icon-fqgd orange-font",
              title: "F/OQC设置",
              path: "/quality/foqcset_list",
              enabled: true,
            },
            {
              id: "qcSample",
              logo: "iconfont icon-fqgd blue-font",
              title: "抽样标准设置",
              path: "/quality/qcsample_list",
              enabled: true,
            },
            {
              id: "qcAql",
              logo: "iconfont icon-zlbz blue-font",
              title: "AQL质量标准",
              path: "/quality/qcaql_list",
              enabled: true,
            },
            {
              id: "qcNgCodeSet",
              logo: "iconfont icon-bldm blue-font",
              title: "检验不良代码",
              path: "/quality/qcngcodeset_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-finance-1",
          title: "应收管理",
          enabled: true,
          items: [
            {
              id: "receivableSchedule",
              logo: "iconfont icon-yfpc blue-font",
              title: "应收排程",
              path: "/finance/receivable_schedule",
              enabled: true,
            },
            {
              id: "receivableInvoice",
              logo: "iconfont icon-fp green-font",
              title: "应收发票",
              path: "/money/receivable_invoice_list",
              enabled: true,
            },
            {
              id: "otherBillAr",
              logo: "iconfont icon-fp orange-font",
              title: "其他应收发票",
              path: "/money/otherbillar_list",
              enabled: true,
            },
            {
              id: "recBackApply",
              logo: "iconfont icon-tksqd red-font",
              title: "退款申请单",
              path: "/money/receipt_apply_list",
              enabled: true,
            },
            {
              id: "recBalanceBack",
              logo: "iconfont icon-tksqd orange-font",
              title: "退款单",
              path: "/money/rec_balance_back_list",
              enabled: true,
            },
            {
              id: "recBbalance",
              logo: "iconfont icon-skd green-font",
              title: "收款单",
              path: "/money/receipt_list",
              enabled: true,
            },
            {
              id: "verification-rec",
              logo: "iconfont icon-hxd orange-font",
              title: "核销单",
              path: "/money/recverify_list",
              enabled: true,
            },
            {
              id: "billAR",
              logo: "iconfont icon-check red-font",
              title: "应收票据",
              path: "/money/rec_billar_list",
              enabled: true,
            },
            {
              id: "billARChange",
              logo: "iconfont icon-ywythd red-font",
              title: "应收票据异动",
              path: "/money/billar_change_list",
              enabled: true,
            },
            {
              id: "othReceivables",
              logo: "iconfont icon-skd blue-font",
              title: "应收调帐单",
              path: "/money/othreceivables_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-finance-2",
          title: "应付管理",
          enabled: true,
          items: [
            {
              id: "paySchedule",
              logo: "iconfont icon-yfpc green-font",
              title: "应付排程",
              path: "/finance/pay_schedule",
              enabled: true,
            },
            {
              id: "payInvoice",
              logo: "iconfont icon-fp blue-font",
              title: "应付发票",
              path: "/money/pay_invoice_list",
              enabled: true,
            },
            {
              id: "otherBillAp",
              logo: "iconfont icon-fp red-font",
              title: "其他应付发票",
              path: "/money/otherbillap_list",
              enabled: true,
            },
            {
              id: "payBalanceBack",
              logo: "iconfont icon-tksqd orange-font",
              title: "退款单",
              path: "/money/pay_balance_back_list",
              enabled: true,
            },
            {
              id: "payPlease",
              logo: "iconfont icon-fksqd orange-font",
              title: "付款申请单",
              path: "/money/payapply_list",
              enabled: true,
            },
            {
              id: "payBalance",
              logo: "iconfont icon-fkd blue-font",
              title: "付款单",
              path: "/money/payment_list",
              enabled: true,
            },
            {
              id: "verification-pay",
              logo: "iconfont icon-fkhxd red-font",
              title: "核销单",
              path: "/money/payverify_list",
              enabled: true,
            },
            {
              id: "billAP",
              logo: "iconfont icon-check blue-font",
              title: "应付票据",
              path: "/money/pay_billap_list",
              enabled: true,
            },
            {
              id: "billAPChange",
              logo: "iconfont icon-ywythd red-font",
              title: "应付票据异动",
              path: "/money/billap_change_list",
              enabled: true,
            },
            {
              id: "othPayables",
              logo: "iconfont icon-fkd green-font",
              title: "应付调账单",
              path: "/money/othpayables_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-finance-3",
          title: "财务管理",
          enabled: true,
          items: [
            {
              id: "fundplan",
              logo: "iconfont icon-zjjh red-font",
              title: "资金计划",
              path: "/finance/fundplan",
              enabled: true,
            },
            {
              id: "journal",
              logo: "iconfont icon-baoxiao orange-font",
              title: "日记账",
              path: "/finance/journal_list",
              enabled: true,
            },
          ],
        },
        {
          id: "nav-oa",
          title: "人事行政",
          enabled: true,
          items: [
            {
              id: "oa-org",
              logo: "iconfont icon-ryzz blue-font",
              title: "人员组织",
              path: "/sys/org/0",
              enabled: true,
            },
            {
              id: "oa-virtual-org",
              logo: "iconfont icon-ryzz green-font",
              title: "商协通",
              path: "/sys/virtual_org/0",
              enabled: true,
            },
            {
              id: "oa_entry",
              logo: "iconfont icon-rzsq orange-font",
              title: "入职申请",
              path: "/oa/entry_apply_list",
              enabled: true,
            },
            {
              id: "vacation",
              logo: "iconfont icon-qingjia blue-font",
              title: "请假",
              path: "/oa/vacation_list",
              enabled: true,
            },
            {
              id: "outapply",
              logo: "iconfont icon-waichu blue-font",
              title: "外出",
              path: "/oa/travel_list",
              enabled: true,
            },
            {
              id: "workovertime",
              logo: "iconfont icon-jiaban orange-font",
              title: "加班",
              path: "/oa/overtime_list",
              enabled: true,
            },
            {
              id: "mobilesigncard",
              logo: "iconfont icon-buka blue-font",
              title: "补卡",
              path: "/oa/signcard_list",
              enabled: true,
            },
            {
              id: "changeclass",
              logo: "iconfont icon-tiaoban green-font",
              title: "调班",
              path: "/oa/changeclass_list",
              enabled: true,
            },
            {
              id: "repairclass",
              logo: "iconfont icon-buban red-font",
              title: "补班",
              path: "/oa/repairclass_list",
              enabled: true,
            },
            {
              id: "workreport",
              logo: "iconfont icon-gzbg orange-font",
              title: "工作报告",
              path: "/oa/workreport_list",
              enabled: true,
            },
            {
              id: "meeting",
              logo: "iconfont icon-gzbg blue-font",
              title: "会议管理",
              path: "/oa/meet",
              enabled: true,
            },
            {
              id: "feeBudget",
              logo: "iconfont icon-sjgl red-font",
              title: "费用预算",
              path: "/oa/fee_budget_list",
              enabled: true,
            },
            {
              id: "feeApply",
              logo: "iconfont icon-ypbj green-font",
              title: "费用申请",
              path: "/oa/fee_apply_list",
              enabled: true,
            },
            {
              id: "feePlease",
              logo: "iconfont icon-baoxiao orange-font",
              title: "报销",
              path: "/oa/fee_list",
              enabled: true,
            },
            {
              id: "loan",
              logo: "iconfont icon-jiekuan blue-font",
              title: "借款",
              path: "/oa/loan_list",
              enabled: true,
            },
            {
              id: "officialseal",
              logo: "iconfont icon-yongyin red-font",
              title: "用印",
              path: "/oa/seal_list",
              enabled: true,
            },
            {
              id: "supplies",
              logo: "iconfont icon-ypsq green-font",
              title: "用品申请",
              path: "/oa/supplies_apply_list",
              enabled: true,
            },
            {
              id: "RecruitApply",
              logo: "iconfont icon-zhaopin green-font",
              title: "招聘",
              path: "/oa/recruit_list",
              enabled: true,
            },
            {
              id: "Notify",
              logo: "iconfont icon-tongzhi orange-font",
              title: "通知",
              path: "/oa/notify_list",
              enabled: true,
            },
            {
              id: "turnposition",
              logo: "iconfont icon-ryyd red-font",
              title: "人员异动",
              path: "/oa/empchange_list",
              enabled: true,
            },
            {
              id: "salarysetchangeapply",
              logo: "iconfont icon-fcsp red-font",
              title: "调薪申请",
              path: "/oa/salaryset_change_list",
              enabled: true,
            },
            {
              id: "hr-attendance",
              logo: "iconfont icon-kaoqin red-font",
              title: "考勤表",
              path: "/oa/attendance_list",
              enabled: true,
            },
            {
              id: "hr-wage",
              logo: "iconfont icon-xjllb orange-font",
              title: "工资表",
              path: "/oa/wage_list",
              enabled: true,
            },
            {
              id: "companySystem",
              logo: "iconfont icon-gszd blue-font",
              title: "公司制度",
              path: "/oa/regulation_list",
              enabled: true,
            },
            {
              id: "contract",
              logo: "iconfont icon-hetong orange-font",
              title: "合同",
              path: "/oa/contract_list",
              enabled: true,
            },
            {
              id: "repairApply",
              logo: "iconfont icon-weibao blue-font",
              title: "维保",
              path: "/oa/repair_list",
              enabled: true,
            },
            {
              id: "fixedAssets",
              logo: "iconfont icon-gdzc green-font",
              title: "固定资产",
              path: "/oa/fixed_assets_list",
              enabled: true,
            },
            {
              id: "visitInner",
              logo: "iconfont icon-lfjl orange-font",
              title: "来访记录",
              path: "/oa/visit_inner_list",
              enabled: true,
            },
            {
              id: "equipment",
              logo: "iconfont icon-equipment red-font",
              title: "设备管理",
              path: "/oa/equipment_list",
              enabled: true,
            },
            {
              id: "equipmentCheck",
              logo: "iconfont icon-check green-font",
              title: "设备点检",
              path: "/oa/equipment_check_list",
              enabled: true,
            },
            {
              id: "authApply",
              logo: "iconfont icon-qmtz red-font",
              title: "权限申请",
              path: "/oa/auth_apply_list",
              enabled: true,
            },
            {
              id: "exam",
              logo: "iconfont icon-gzbg orange-font",
              title: "考试管理",
              path: "/oa/exam_list",
              enabled: true,
            },
            {
              id: "worktask",
              logo: "iconfont icon-shwx orange-font",
              title: "工作任务",
              path: "/oa/worktask_list",
              enabled: true,
            },
          ],
        },
      ],
    };
  },
};
</script>